import React from 'react';
import { useTranslations } from '../../../../hooks/useTranslations';
import { MediumHeader } from '../../../ui/Header/Header';
import Paragraph from '../../../ui/Paragraph/Paragraph';
import PickupLocationIcon from './PickupLocationIcon';
import styles from './PickupLocationNotFound.module.css';

const PickupLocationNotFound = () => {
  const { locationNotFoundHeader, locationNotFoundDescription } =
    useTranslations();

  return (
    <div className={styles.root}>
      <PickupLocationIcon />
      {locationNotFoundHeader && (
        <MediumHeader as="p" containerCustomStyle={{ marginTop: '1rem' }}>
          {locationNotFoundHeader}
        </MediumHeader>
      )}
      <Paragraph>{locationNotFoundDescription}</Paragraph>
    </div>
  );
};

export default PickupLocationNotFound;
